import MarkdownIt from "markdown-it";
import * as R from "ramda";
import { getRelByHref, getTargetByHref } from "./utils";
import { isRunningInBrowser } from "./ssr";

const md = new MarkdownIt({ html: true, breaks: true });

type AttributeName = "onclick";

export interface Attribute {
    name: AttributeName,
    value: string;
}

interface RenderEnv {
    attributes?: Attribute[];
}

// Remember old renderer, if overridden, or proxy to default renderer
const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
}

if (isRunningInBrowser()) {
    md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        if (!R.isNil(token)) {
            const setAttr = (attrName: "target" | "rel", href: string, getValue: (href: string) => string | undefined) => {
                if (token.attrGet(attrName) === null) {
                    const attrValue = getValue(href);
                    if (attrValue !== undefined) {
                        token.attrPush([attrName, attrValue]);
                    }
                }
            }

            const href = token.attrGet("href");
            if (href !== null) {
                setAttr("target", href, getTargetByHref);
                setAttr("rel", href, getRelByHref);

                const typedEnv = env as RenderEnv;
                typedEnv?.attributes?.forEach(attr => {
                    token.attrSet(attr.name, attr.value);
                });
            }
        }

        // pass token to default renderer.
        return defaultRender(tokens, idx, options, env, self);
    }
}

const markdownRender = (content: string, attributes?: Attribute[]): string => {
    const env: RenderEnv = {
        attributes
    }
    return md.render(content, env);
}

export default markdownRender;